import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Nav from './Nav';
import Footer from './Footer';

export default function Layout({ children, transparentNav = false }) {
  const { t } = useTranslation();
  const location = useLocation();
  const reduce = useReducedMotion();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  const content = reduce ? (
    <main id="main-content">{children}</main>
  ) : (
    <motion.main
      id="main-content"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      key={location.pathname}
    >
      {children}
    </motion.main>
  );

  return (
    <div className="min-h-screen bg-brand-background flex flex-col">
      <a href="#main-content" className="skip-to-content">
        {t('skipToContent')}
      </a>
      <Nav transparentOnHero={transparentNav} />
      {content}
      <Footer />
    </div>
  );
}
